var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 10.0003C6.66667 10.4587 7.04167 10.8337 7.5 10.8337H14.1667C14.625 10.8337 15 10.4587 15 10.0003C15 9.54199 14.625 9.16699 14.1667 9.16699H7.5C7.04167 9.16699 6.66667 9.54199 6.66667 10.0003ZM10.8333 1.66699C6.23333 1.66699 2.5 5.40033 2.5 10.0003C2.5 14.6003 6.23333 18.3337 10.8333 18.3337C15.4333 18.3337 19.1667 14.6003 19.1667 10.0003C19.1667 5.40033 15.4333 1.66699 10.8333 1.66699ZM10.8333 16.667C7.15833 16.667 4.16667 13.6753 4.16667 10.0003C4.16667 6.32533 7.15833 3.33366 10.8333 3.33366C14.5083 3.33366 17.5 6.32533 17.5 10.0003C17.5 13.6753 14.5083 16.667 10.8333 16.667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCircle);
export default __webpack_public_path__ + "static/media/remove-circle.dba8432e758bdeb9cc23659be9f92ddb.svg";
export { ForwardRef as ReactComponent };